'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Venue = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Venue = exports.Venue = function Venue() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, Venue);

  _initialiseProps.call(this);

  (0, _assign2.default)(this, {
    activities: data.activities,
    alias: data.alias,
    description: data.description,
    id: data.venue_id || data.id,
    images: {
      small: Venue.getImage(data, '1x'),
      smallVertical: Venue.getImage(data, 'v1x')
    },
    location: data.location || {
      lat: data.lat,
      lon: data.lon
    },
    locationName: (0, _deep.deepExtract)('location.name', data) || data.location_name || data.neighborhood,
    name: data.name || data.venue_name,
    rating: data.display_rating_average,
    ratingCount: data.display_rating_total,
    subtitle: data.subtitle
  });
};

Venue.getImage = function (data, type) {
  var defaultImage = (0, _deep.deepExtract)('images.default', data);
  return (0, _deep.deepExtract)('images.mobile.' + type, data, defaultImage);
};

var _initialiseProps = function _initialiseProps() {
  this.type = 'venue';
};